import { configure, extend } from "vee-validate";

import { digits, email, length, max, min, numeric, regex, required } from "vee-validate/dist/rules";

extend("digits", {
  ...digits,
  message: "This field must be {length} digits long"
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});

extend("length", {
  ...length,
  message: "This field must be {length} characters"
});

extend("max", {
  ...max,
  message: "This field must be {length} characters or less"
});

extend("min", {
  ...min,
  message: "This field must be {length} characters or more"
});

extend("numeric", {
  ...numeric,
  message: "This field must only include numbers"
});

extend("phone", {
  validate: value => {
    return value.charAt(0) !== "0" && value.charAt(0) !== "1" && value.replace(/\D/g, "").length === 10;
  },
  message: "Must be 10 digits, cannot start with 0 or 1"
});

extend("phoneCheck", {
  ...regex,
  message: "Must be 10 digits, cannot start with 0 or 1"
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("ccAmexLength", {
  ...min,
  message: "Amex CC format: #### ###### #####"
});

extend("ccCardTypeValid", {
  ...length,
  message: "Invalid card type. Accepted types: Visa, MasterCard, AMEX, Discover"
});

extend("ccStandardLength", {
  ...length,
  message: "Standard CC format: #### #### #### ####"
});

extend("credit_card", {
  ...required,
  validate: value => {
    var card_prefix = value.substring(0, 2);
    var is_amex = (card_prefix === "34" || card_prefix === "37");
    /* spaces are added to the card number for readability.  So remove them for checking the length. */
    var len = value.replace(/\s/g, "").length;
    if (is_amex && len === 15) {
      return true;
    }
    if (!is_amex && len === 16) {
      return true;
    }
  },
  message: "A valid credit card number is required"
});

extend("regex", regex);

extend("password", {
  validate: value => {
    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(value);
  },
  message: "Password must have at least 8 characters, one number, and one special character"
});

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});
